var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimeFastIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 15"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "time-fast-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h14v14H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#time-fast-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.833 13.917a.583.583 0 0 1-.583.583H.583a.583.583 0 0 1 0-1.167H5.25a.583.583 0 0 1 .583.584M.583 12.167h3.5a.583.583 0 0 0 0-1.167h-3.5a.583.583 0 0 0 0 1.167M.583 9.833h2.334a.583.583 0 1 0 0-1.166H.583a.583.583 0 0 0 0 1.166"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 .5a7 7 0 0 0-7 7c0 .036.005.07.005.106A1.7 1.7 0 0 1 .583 7.5h2.334a1.744 1.744 0 0 1 1.621 2.401 1.736 1.736 0 0 1 1.167 2.333 1.72 1.72 0 0 1 1.19 2.26c.035 0 .07.006.105.006a7 7 0 1 0 0-14m2.162 9.162a.583.583 0 0 1-.824 0l-1.75-1.75a.58.58 0 0 1-.171-.412V4.583a.583.583 0 1 1 1.166 0v2.675l1.58 1.58a.583.583 0 0 1 0 .824"
}))));
export { SvgTimeFastIcon as ReactComponent };
export default __webpack_public_path__ + "edce93d56729e9a69395e64a455af8b6.svg";